import React, { useState, useRef, useEffect } from "react";
import {
  createComMap,
  deleteComMap,
  getComMapAll,
  updateComMap,
  inActiveComMap,
} from "../../Services/ComMapService";
import { getComProductAll } from "../../Services/ComProductService";
import { getProductsAll } from "../../Services/ProductService";
import { useForm, Controller } from "react-hook-form";
import Swal from "sweetalert2";
import MTable from "../../Components/MTable/MTable";
import { InputSwitch } from "primereact/inputswitch";
import Overlay from "../../Components/Overlay/Overlay";
import { handlerFormError, uuid } from "../../Utils/Utils";
import { toastError, toastSuccess } from "../../Components/Toasts/Toast";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import DeleteButton from "../../Components/Button/DeleteButton";
import { MultiSelect } from "primereact/multiselect";
import { Dropdown } from "primereact/dropdown";

let processingId = -1;

const ComProductMapPage = () => {
  let { userInfo } = useSelector((state) => state.auth);
  const [showAll, setShowAll] = useState(false);
  const mTable = useRef();
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      sales_code: "",
      item_code: "",
      remarks: "",
      is_active: true,
    },
  });

  const [selectedMoItems, setSelectedMoItems] = useState(null);
  const [selectedCoItems, setSelectedCoItems] = useState(null);
  const [state, setState] = useState({
    showForm: false,
    coItems: [],
    prodMap: {},
    sales_code: "",
    item_code: "",
    remarks: "",
    is_active: true,
    processing: false,
  });

  const onActiveChange = (item) => (e) => {
    if (!userInfo.access.competitor_mapping_product.can_update) {
      toastError("You dont have permission for this action");
      return;
    }
    const status = e.target.value ? "Activate" : "Inactive";
    inActiveComMap(item.id, { is_active: e.target.value })
      .then((res) => {
        toastSuccess(`${status} ${item.item_code} Success.`);
        mTable.current.refresh();
      })
      .catch(({ response: { err } }) => {
        toastError(`${status} Failed.`);
      });
  };

  const columns = [
    { id: uuid(), title: "Segment", field: "segment_name", sortable: true },
    { id: uuid(), title: "Category", field: "category_name", sortable: true },
    {
      id: uuid(),
      title: "Sub-Category",
      field: "sub_category_name",
      sortable: true,
    },
    {
      id: uuid(),
      title: "Sub Sub-Category",
      field: "sub_sub_category_name",
      sortable: true,
    },
    { id: uuid(), title: "Item Code", field: "item_code", sortable: true },
    { id: uuid(), title: "Sales Code", field: "sales_code", sortable: true },
    { id: uuid(), title: "Remarks", field: "remarks", sortable: true },
    {
      id: uuid(),
      title: "Active",
      field: "is_active",
      filterable: false,
      render: (item) => {
        if (item.is_active === true) {
          return <span className="badge badge-success">Active</span>;
        } else {
          return <span className="badge badge-secondary">Inactive</span>;
        }
      },
    },
    {
      id: uuid(),
      title: "",
      sortable: true,
      style: { width: 200 },
      render: (item) => {
        return (
          <div>
            {/* <EditButton title="Edit" onClick={onEdit(item)} /> */}
            {userInfo.access.competitor_mapping_product.can_delete && (
              <DeleteButton title="Remove" onClick={onRemove(item)} />
            )}
          </div>
        );
      },
    },
  ];

  const showAllFunc = () => {
    setShowAll(!showAll);
    mTable.current.refresh();
  };

  const propsTable = {
    columns,
    showAllState: showAll,
    showAllFunc,
    getData: (params) => {
      if (showAll === false) {
        if (params.filterAnd) params.filterAnd += "," + `is_active:true`;
        else params.filterAnd = "is_active:true";
      }
      return getComMapAll({ ...params });
    },
    enableFilter: true,
    showAddButton: !userInfo.access.competitor_mapping_product.can_create
      ? false
      : true,
  };

  const removeData = (id) => {
    deleteComMap(
      id,
      (res) => {
        if (res.status == 200 || res.status == 201) {
          Swal.fire({
            icon: "success",
            title: "Delete data success",
            text: "Data has been deleted!",
          }).then((res) => {
            mTable.current.refresh();
          });
        }
      },
      ({ response: { data } }) => {
        Swal.fire({
          icon: "error",
          title: "Delete data fail",
          text: data.message,
        });
      }
    );
  };

  const onEdit = (item) => () => {
    reset(item);
    setState({ ...state, prodMap: item, showForm: true });
  };

  const onRemove = (item) => () => {
    if (!userInfo.access.competitor_mapping_product.can_delete) {
      toastError("You dont have permission for this action");
      return;
    }

    Swal.fire({
      icon: "question",
      title: "Are you sure?",
      text: "Deleted data can not be restored!",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
    }).then(({ isConfirmed }) => {
      if (isConfirmed) {
        removeData(item.id);
      }
    });
  };

  const onAddData = () => {
    if (!userInfo.access.competitor_mapping_product.can_create) {
      return;
    }
    onReset();
    setState({ ...state, showForm: true });
  };

  const startProcessing = () => {
    processingId = setTimeout(() => {
      setState({ ...state, processing: true });
    }, 150);
  };

  const stopProcessing = () => {
    clearTimeout(processingId);
    setState({ ...state, processing: false });
  };

  const onSubmit = (data) => {
    // console.log('selectedMoItems', selectedMoItems)
    data.item_code = selectedMoItems.code;
    data.sales_code = selectedCoItems;
    startProcessing();
    const response = prodMap.id
      ? updateComMap(prodMap.id, data)
      : createComMap(data);
    response
      .then((res) => {
        if (res.status == 200 || res.status == 201) {
          Swal.fire({
            icon: "success",
            title: "Save data success",
            text: "Data has been saved!",
          }).then((r) => {
            mTable.current.refresh();
            prodMap.id ? onCloseForm() : onReset();
          });
        }
      })
      .catch(({ response: { data } }) => {
        handlerFormError(data);
      })
      .finally((_) => stopProcessing());
  };

  const onReset = () => {
    reset({
      sales_code: "",
      item_code: "",
      remarks: "",
      is_active: true,
    });
    setSelectedMoItems(null);
    setSelectedCoItems(null);
    setState({ ...state, prodMap: {}, coItems: [] });
  };

  const onCloseForm = () => {
    onReset();
    setState({ ...state, prodMap: {}, showForm: false });
  };

  const setChange = (e) => {
    setSelectedMoItems(e.value);
    getComProductAll(
      {
        perpage: 100,
        filter: `is_active:true,id_sub_category:${e.target.value.id}`,
        select: `sales_code,product_name`,
      },
      ({ data }) => {
        var arr = [];
        data.data.map((item) => {
          arr.push({ code: item.sales_code, name: item.product_name });
        });
        setState({ ...state, coItems: arr });
      }
    );
  };

  useEffect(() => {
    getProductsAll(
      {
        perpage: 1000,
        filter: `is_active:true,country_code:id`,
        select: `id_sub_category,item_code,model_code`,
      },
      ({ data }) => {
        var arr = [];
        data.data.map((item) => {
          arr.push({
            id: item.id_sub_category,
            code: item.item_code,
            name: item.model_code,
          });
        });
        setState({ ...state, moItems: arr });
      }
    );
  }, []);

  const { prodMap, moItems, coItems, processing, showForm } = state;

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h4
                style={{
                  marginTop: "0.5rem",
                  marginLeft: "0.2rem",
                  fontWeight: "400",
                }}
              >
                {showForm
                  ? "Competitor Product Mapping Form"
                  : "Competitor Product Mapping Management"}
              </h4>
              <h6
                style={{
                  marginLeft: "0.2rem",
                  fontWeight: "200",
                  letterSpacing: "1.2px",
                }}
              >
                {showForm
                  ? "Add/Edit a Competitor Product Mapping"
                  : "Database of Competitor Product Mappings"}
              </h6>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <NavLink to="/home">Home</NavLink>
                </li>
                <li className="breadcrumb-item active">Competitor</li>
                <li className="breadcrumb-item active">Mapping</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <Overlay display={processing} />

                <form name="form-detail" onSubmit={handleSubmit(onSubmit)}>
                  <div className="card-body">
                    <div
                      className={`${
                        !showForm
                          ? "card__side--front-show"
                          : "card__side--front"
                      }`}
                    >
                      <MTable
                        ref={mTable}
                        {...propsTable}
                        onAddData={onAddData}
                        showIndex={true}
                      />
                    </div>

                    <div
                      className={`${
                        showForm ? "card__side--back-show" : "card__side--back"
                      }`}
                    >
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="item_code">MODENA Item Code</label>
                            <Dropdown
                              value={selectedMoItems}
                              onChange={(e) => setChange(e)}
                              options={moItems}
                              optionLabel="name"
                              id="item_code"
                              placeholder="Select a Item"
                              className="form-control"
                              style={{ height: 50 }}
                            />
                            {/* {errors.item_code && (<span className='text-danger' style={{ fontSize: 14 }}>{errors.item_code.message}</span>)} */}
                          </div>
                          <div className="form-group">
                            <label htmlFor="sales_code">
                              Competitor Item Code
                            </label>
                            <MultiSelect
                              value={selectedCoItems}
                              onChange={(e) => setSelectedCoItems(e.value)}
                              options={coItems}
                              optionLabel="name"
                              display="chip"
                              id="sales_code"
                              placeholder="Select Items"
                              maxSelectedLabels={3}
                              className="form-control"
                              style={{ height: 50 }}
                            />
                            {/* {errors.sales_code && (<span className='text-danger' style={{ fontSize: 14 }}>{errors.sales_code.message}</span>)} */}
                          </div>
                          <div className="form-group">
                            <label htmlFor="is_active">Active</label>
                            <div>
                              <Controller
                                name="is_active"
                                control={control}
                                render={({ field }) => {
                                  return (
                                    <InputSwitch
                                      {...field}
                                      checked={field.value}
                                    />
                                  );
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="remarks">Remarks</label>
                            <textarea
                              style={{ resize: "none", whiteSpace: "pre-wrap" }}
                              id="remarks"
                              {...register("remarks")}
                              className="form-control"
                              rows={5}
                              disabled={false}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {showForm && (
                    <div className="card-footer delay">
                      <div className="row">
                        <div className="col-md-12">
                          <div
                            className="d-flex"
                            style={{ justifyContent: "flex-end" }}
                          >
                            <button
                              type="button"
                              className="btn btn-default mr-3"
                              style={{ width: 100 }}
                              onClick={onCloseForm}
                            >
                              <i className="fa fa-times" /> Close
                            </button>
                            <button
                              type="button"
                              className="btn btn-danger mr-3"
                              style={{ width: 100 }}
                              onClick={onReset}
                            >
                              <i className="fa fa-sync" /> Clear
                            </button>
                            <button
                              type="submit"
                              className="btn btn-dark"
                              style={{ width: 100 }}
                              disabled={
                                control._formValues.id
                                  ? !userInfo.access.competitor_mapping_product
                                      .can_update
                                  : !userInfo.access.competitor_mapping_product
                                      .can_create
                              }
                            >
                              <i className="fa fa-save" /> Save
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ComProductMapPage;
